import React from "react";
import { Dashboard } from "../modules/dashboards/Dashboard";

export function DashboardPage() {
  return <Dashboard />;
}
